import React, { useEffect, useState, Suspense, lazy } from "react";
import MediaQuery from 'react-responsive';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './App.css';
import Navbar from './components/Navbar';
import axios from "axios";
import PavanSpeech from './components/PavanSpeech';
import desktopbg from './Images/desktop-bg.webp';
import ThankYou from './components/ThankYou';
import Loader from './components/Loader';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import jsonData from "./ai-branding.json"; // Import the JSON file

const Header = lazy(() => import("./components/Header"));
const SocialMedia =lazy(() => import("./components/SocialMedia"));
const SocialMediaDesk = lazy(() => import("./components/SocialMediaDesk"));
const Gallery = lazy(() => import("./components/Gallery.js"));
const SubscribeForEventNotifications = lazy(() => import("./components/SubscribeForEventNotifications"));
const ContactUs = lazy(() => import("./components/ContactUs"));
const Footer = lazy(() => import("./components/Footer"));
const Video = lazy(() => import('./components/PavanVideo/Video.js'));


function App() {


  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  const imgCDNURL = process.env.REACT_APP_CALIFORNIAEXPO_CDN_URL;
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  return (
    <>

<CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
    {links ? (
    <>
      <div className="appBodyContainer">
        
        <img src= {desktopbg} className="desktop-bg img-fluid" alt="desktop-bg"/> 
        <img src={imgCDNURL + "mobile-banner.webp"} className="mobile-bg img-fluid" alt="mobile-bg" />
        <img src={imgCDNURL + "flower.webp"} className="flower1 img-fluid" alt="flower" />
        <img src={imgCDNURL + "flower.webp"} className="flower2 img-fluid" alt="flower" />
        <img src={imgCDNURL + "flower.webp"} className="flower3 img-fluid" alt="flower" />
       
        </div>
        <Navbar />  
        <Suspense fallback={<div />}>
          <Header handleVideo={handleVideo} videoToggle={videoToggle}/>
        </Suspense>
        < PavanSpeech links={links.current}/>
 
      
      <Suspense fallback={<div />}>
      <Gallery />  
      {/* <EventMemories />   */}
      </Suspense>

       {/* Renders the components of desktop view */}
      <MediaQuery minWidth={992}>
      <Suspense fallback={<div/>}>
        <SocialMediaDesk />
        </Suspense>
      </MediaQuery>
      {/* Renders the components of mobile and tablet view */}
      <MediaQuery maxWidth={991}>
      <Suspense fallback={<div/>}>
        <SocialMedia />
        </Suspense>
      </MediaQuery>
      <Suspense fallback={<div />}>
      <ThankYou />
      </Suspense> 
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense> 
      <Suspense fallback={<div />}>
        <ContactUs />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && <Video handleVideo={handleVideo} videoToggle={videoToggle}/>}
      </Suspense>

      </>
    ) : (
      <div>Loading...</div>
    )}
    </CacheBuster>
    </>
  );
}

export default App;
